var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',_vm._l((_vm.actions),function(label,action){return _c('b-button',{key:action,staticClass:"resultBtn",attrs:{"pressed":_vm.actionBtn[action],"pill":"","size":"sm","variant":"outline-info"},on:{"click":function($event){return _vm.handleClick(action)}}},[_vm._v(" "+_vm._s(label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }